import { BadgeProps, BadgeWithStatus } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import { BadgeVariant, mapBadgeVariant } from '../../app-kit/helpers/mapBadgeVariant';

export interface LabelBadgeProps extends BadgeProps {
  title: string;
  badgeVariant: BadgeVariant;
}

export const LabelBadge: FunctionComponent<LabelBadgeProps> = ({ title, badgeVariant }) => (
  <BadgeWithStatus variant={mapBadgeVariant(badgeVariant)}>{title}</BadgeWithStatus>
);
